<template>
  <div>
    <div class="add-to-cart-options">
      <div class="quantity-group">
        <!-- TODO: WA-4857 -->
        <!-- eslint-disable vue/no-mutating-props -->
        <QuantityWidget
          :id="product.title"
          :quantity="quantity"
          :quantity-limit="quantityLimit"
          type="text"
          :available="available"
          @clear-errors="clearErrors()"
          @set-quantity="(qty) => $emit('set-quantity', qty)"
        />
        <!-- eslint-enable -->
        <button
          class="quantity-change decrease"
          :disabled="!available"
          @click="incrementQuantity(-1)"
        >
          <span class="show-for-sr">Decrease</span>
        </button>
        <button
          v-if="quantityLimit === null || quantityLimit > 1"
          class="quantity-change increase"
          :disabled="!available"
          @click="incrementQuantity(1)"
        >
          <span class="show-for-sr">Increase</span>
        </button>
      </div>
      <div class="add-to-cart">
        <button
          v-if="available"
          :data-product-id="product.product_id"
          @click="addToCart"
        >
          {{ addText }}
        </button>
      </div>
      <div
        v-if="
          showHeartIcon && !product.is_sampler && !product.is_ninja_instance
        "
        class="heart-icon"
      >
        <HeartIcon :product="product" />
      </div>
    </div>
    <button
      v-if="notificationChecked && !available"
      class="button disable-top"
      @click="disableNotification"
    >
      Disable notification
    </button>
    <ErrorList v-if="errors.length" :errors="errors" />
  </div>
</template>

<script>
import {
  disableNotificationService,
  incrementQuantityWidget,
  isAvailable,
  requestedNotification,
} from '#common/utils/catalog'
import { baseURL } from '#common/utils/url'
import { mapGetters } from 'vuex'
export default {
  components: {
    QuantityWidget: defineAsyncComponent(
      () => import('@/components/Product/QuantityWidget'),
    ),
    ErrorList: defineAsyncComponent(
      () => import('#common/components/ErrorList.vue'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    quantityLimit: {
      type: Number,
      default: null,
    },
    addText: {
      type: String,
      default: 'Add to Cart',
    },
    addType: {
      type: String,
      default: 'addToCart',
    },
    partnerId: {
      type: Number,
      default: null,
    },
    showHeartIcon: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['set-quantity', 'request-started', 'add-to-cart', 'request-ended'],
  data() {
    return {
      errors: [],
    }
  },
  computed: {
    ...mapGetters(['pptoCart', 'futuresCart']),
    available() {
      return isAvailable(
        this.$auth.user,
        this.product,
        this.partnerId,
        this.$config.public.validSiteIds,
      )
    },
    notificationChecked() {
      return requestedNotification(this.$auth.user, this.product.product_id)
    },
    isPpto() {
      return this.addType === 'addToPPTOCart'
    },
    isFutures() {
      return this.addType === 'addToFuturesCart'
    },
  },
  methods: {
    clearErrors() {
      this.errors = []
    },
    setQuantity(newValue) {
      this.$emit('set-quantity', newValue)
    },
    async addToCart() {
      this.$emit('request-started')
      this.clearErrors()
      const addToCartData = {
        quantity: this.quantity,
        product_id: this.product.product_id,
        source_url: baseURL() + this.$route.fullPath,
      }
      if (this.isPpto) {
        addToCartData.post_purchase_order = this.pptoCart.post_purchase_order
      }
      try {
        await this.$store.dispatch(this.addType, addToCartData)
        this.$emit('add-to-cart', this.product)
      } catch (e) {
        console.error(e.reason)
        let theError = e.reason
        if (e.reason.non_field_errors) theError = e.reason.non_field_errors[0]
        this.errors = [theError]
      } finally {
        this.$emit('request-ended')
      }
    },
    incrementQuantity(amount) {
      this.clearErrors()
      if (!this.quantityLimit || this.quantity + amount <= this.quantityLimit) {
        this.setQuantity(incrementQuantityWidget(amount, this.quantity))
      }
    },
    async disableNotification() {
      await disableNotificationService(
        this.$axios,
        this.product.product_id,
        this.$auth.user,
      )
    },
  },
}
</script>
